import { getState } from './state.js';
/**
 * Returns the current access token, or `null` when unauthenticated.
 *
 * The function reference is stable, so it can be passed to
 * `configureHttp({ getAccessToken })` once at bootstrap time.
 */
export function getAccessToken() {
    return getState().accessToken;
}
/** Current user, or `null` when unauthenticated. */
export function getUser() {
    return getState().user;
}
/**
 * `true` when a user is logged in (state has both an access token and a
 * resolved `user`). The shell uses this to choose between `<LoginScreen>`
 * and authenticated chrome.
 */
export function isAuthenticated() {
    const s = getState();
    return s.user !== null && s.accessToken !== null;
}
/**
 * Like `getUser()` but throws when there is no authenticated user. Use inside
 * the authenticated tree (sub-app mount points) where the absence of a user
 * is a programming error, not a runtime state.
 */
export function requireUser() {
    const user = getState().user;
    if (!user) {
        throw new Error('requireUser: no authenticated user');
    }
    return user;
}
/** Apps the current user is permitted to mount. Stable reference. */
export function getAllowedApps() {
    return getState().allowedApps;
}
/** Convenience over `user.roles`. */
export function hasRole(role) {
    const user = getState().user;
    return user?.roles.includes(role) ?? false;
}
/** Convenience over `allowedApps`. */
export function hasAppAccess(appId) {
    return getState().allowedApps.some((app) => app.id === appId);
}
//# sourceMappingURL=selectors.js.map